import { render } from "./BlocoFinanceiro.vue?vue&type=template&id=ae18613a"
import script from "./BlocoFinanceiro.vue?vue&type=script&lang=js"
export * from "./BlocoFinanceiro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__